import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { IoMdArrowDropright } from "react-icons/io";
import ConfirmationModal from "../../../components/Staff/Modals/ConfirmationModal";
import Cookies from "js-cookie";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableRowSkeleton = () => (
  <tr className="border-gray-300 border-b">
    {[...Array(4)].map((_, index) => (
      <td key={index} className="border-[#dbdbdb] p-2 border-r text-center">
        <Skeleton width={index === 0 ? 30 : 80} />
      </td>
    ))}
  </tr>
);

const TableHeaderSkeleton = () => (
  <tr>
    {[...Array(4)].map((_, index) => (
      <th
        key={index}
        className="p-3 border-r font-medium text-[13px] text-center whitespace-nowrap"
      >
        <Skeleton width={index === 0 ? 30 : 80} />
      </th>
    ))}
  </tr>
);

const PaginationSkeleton = () => (
  <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md">
    <div className="pt-2 pb-[8px] px-2">
      <Skeleton width={60} />
    </div>
    <div className="pt-2 pb-[8px] px-3">
      <Skeleton width={20} />
    </div>
    <div className="pt-2 pb-[8px] px-2">
      <Skeleton width={40} />
    </div>
  </div>
);

const TaskPriority = () => {
  const [open11, setOpen11] = useState(false);
  const onOpenModal11 = () => setOpen11(true);
  const onCloseModal11 = () => setOpen11(false);
  const [openIndex, setOpenIndex] = useState(null);
  const { baseUrl, openToast } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);

  // Function to handle accordion toggling
  const handleToggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null); // Close the accordion if clicked again
    } else {
      setOpenIndex(index); // Open the accordion
    }
  };
  //salary dropdown
  const [isOpen1, setIsOpen1] = useState(false);

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  //salary dropdown

  //Toggle swich off on btn
  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  //Toggle swich off on btn

  //Modal
  // State to control the visibility of the modal
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the modal
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  //Modal2
  //Modal
  // State to control the visibility of the modal
  const [isOpen3, setIsOpen3] = useState(false);

  // Function to toggle the modal
  const toggleModal3 = () => {
    setIsOpen3(!isOpen3);
  };

  //Modal2

  const [isOpen5, setIsOpen5] = useState(true);

  // Toggle the visibility of tbody
  const toggleTable = () => {
    setIsOpen5(!isOpen5);
  };

  let subtitle;

  const [modalIsOpen6, setIsOpen6] = React.useState(false);
  function openModal6() {
    setIsOpen6(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal6() {
    setIsOpen6(false);
  }

  const [priorityName, setPriorityName] = useState();
  async function submitPriority() {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + "task/priority", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ taskPriorityName: priorityName }),
      });
      if (result.status == 201) {
        const data = await result.json();
        setIsLoading(false);
        openToast(data.message, "success");
        toggleModal();
        fetchPriority();
      } else {
        const error = await result.json();
        openToast(error.message || "internal server error", "error");
      }
    } catch (error) {
      console.error("Error in POST request:", error);

      // Specific handling for "Failed to fetch"
      if (error.message === "Failed to fetch") {
        openToast("Network error: Unable to connect to the server", "error");
      } else {
        openToast(error.message || "An unexpected error occurred", "error");
      }
    } finally {
      setIsLoading(false);
    }
  }

  const [priorityHeading, setPriorityHeading] = useState([]);
  async function fetchPriority() {
    try {
      setIsLoading(true);
      const result = await fetch(baseUrl + "task/priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const res = await result.json();
        setPriorityHeading(res.taskPriority);
      } else {
        const error = await result.json();
        throw new Error(error.message || "Internal Server Error", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchPriority();
  }, []);

  const [exportFormat, setExportFormat] = useState("");
  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printDepartments();
  };

  const exportCSV = () => {
    const csvData = priorityHeading
      .map((dep) => `${dep.taskPriorityName}`)
      .join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "Priority Name.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Priority Name", 20, 10);
    priorityHeading.forEach((dep, index) => {
      doc.text(`${index + 1}. ${dep.taskPriorityName}`, 10, 20 + index * 10);
    });
    doc.save("Priority Name.pdf");
  };

  const printDepartments = () => {
    const printContent = priorityHeading
      .map((dep) => `${dep.taskPriorityName} `)
      .join("\n");
    const newWindow = window.open();
    newWindow.document.write(`<pre>${printContent}</pre>`);
    newWindow.document.close();
    newWindow.print();
  };
  const [rowsToShow, setRowsToShow] = useState(25);
  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  function openModal6() {
    setIsOpen6(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal6() {
    setIsOpen6(false);
  }

  const [selectedPriority, setSelectedPriority] = useState();
  const handlePrioritySelect = (opt) => {
    setSelectedPriority(opt);
    openModal6();
  };

  const deletePriority = async (id) => {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + `task/priority/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        fetchPriority();
        setIsLoading(false);
        openToast("Deleted Successfully", "success");
        setOpen11(false);
      } else {
        const error = await result.json();
        openToast(error.message || "Internal Server Error", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [updatePriority, setUpdatePriority] = useState("");
  async function updateTaskPriority() {
    const taskPriorityId = selectedPriority.id;
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + `task/priority/${taskPriorityId}`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ taskPriorityName: updatePriority }),
      });
      if (result.status == 200) {
        fetchPriority();
        setIsLoading(false);
        closeModal6();
        openToast("Update Task Name Successfully", "success");
      } else {
        const error = await result.json();
        throw new Error(error.message || `HTTP Error: ${result.status}`);
      }
    } catch (error) {
      console.error("Error fetching task status:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const [open8, setOpen8] = useState(false);

  return (
    <div className="w-full">
      <div className="bg-[#fff] p-[10px]">
        <div className="set-shadow p-[20px] rounded-md w-full">
          <div className="flex items-center gap-[14px] mb-[10px]">
            <div className="flex justify-center items-center h-[50px] text-[14px]">
              {/* Button to open the modal */}
              <button onClick={toggleModal} className="second-btn">
                Add Task Priority
              </button>

              {/* Modal (visible only when isOpen is true) */}
              {isOpen && (
                <div className="z-[1] fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
                  <div className="bg-white shadow-lg rounded-lg w-96">
                    {/* Modal Header */}
                    <div className="px-4 py-2 border-b">
                      <h2 className="font-semibold text-lg">
                        Create New Priority
                      </h2>
                    </div>

                    {/* Modal Body */}
                    <div className="p-4">
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Priority Name</label>
                        <br />
                        <input
                          type="text"
                          onChange={(e) => setPriorityName(e.target.value)}
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-end gap-[10px] px-4 py-2 border-t">
                      <button
                        onClick={toggleModal}
                        className="px-4 py-2 first-btn"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={submitPriority}
                        className={` ${
                          isLoading ? "second-btn-disabled" : "second-btn"
                        }                                               `}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start gap-[10px] mb-[14px]">
            <div className="flex items-center gap-[10px]">
              <div className="inline-block relative text-left">
                {/* Button to open/close the dropdown */}
                <select
                  onChange={handleSelectChange}
                  className="border-[#e5e7eb] shadow-sm mr-2 p-[7px] pr-3 border rounded-md text-[14px] focus:outline-none"
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="120">120</option>
                </select>

                {/* Dropdown menu */}
                {isOpen1 && (
                  <div className="right-0 left-[0px] z-10 absolute border-gray-200 bg-white shadow-lg mt-2 border rounded-md w-[100%] origin-top-right">
                    <div
                      className=""
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        30
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        40
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        50
                      </a>
                    </div>
                  </div>
                )}
              </div>

              <select
                onChange={(e) => setExportFormat(e.target.value)}
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md text-[14px] text-sm focus:outline-none"
              >
                <option value="CSV">CSV</option>
                <option value="PDF">PDF</option>
                <option value="Print">Print</option>
              </select>
              <button onClick={handleExport} className="second-btn">
                Export
              </button>
            </div>
            <div className="relative w-full md:w-[200px] lg:w-[200px] xl:w-[200px]">
              <input
                className="p-[6px] pr-[25px] summary-border rounded-2xl w-full text-[13px] newsetup3"
                type="text"
                placeholder=" Search......."
              />
              <SearchIcon className="top-[8px] right-[8px] absolute newadd2" />
            </div>
          </div>

          <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto">
            <table className="rounded-md w-full table-auto table-status">
              <thead
                onClick={toggleTable}
                className="set-shadow cursor-pointer"
              >
                {isLoading ? (
                  <TableHeaderSkeleton />
                ) : (
                  <tr>
                    <th className="flex justify-center items-center p-3 border-r font-medium text-center text-xs whitespace-nowrap">
                      <IoMdArrowDropright
                        className={`text-[20px] transition-transform duration-200 ${
                          isOpen5 ? "rotate-90 text-[black]" : "rotate-0"
                        }`}
                      />
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      ID
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Priority Name
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Action
                    </th>
                  </tr>
                )}
              </thead>
              <tbody
                className={`transition-all duration-500 ease-in-out overflow-hidden ${
                  isOpen5 ? "table-row-group" : "hidden"
                }`}
              >
                {isLoading ? (
                  [...Array(10)].map((_, index) => (
                    <TableRowSkeleton key={index} />
                  ))
                ) : priorityHeading && priorityHeading.length > 0 ? (
                  priorityHeading?.map((priorityName, index) => (
                    <tr key={index} className="border">
                      <td className="border-[#dbdbdb] border-r text-left whitespace-nowrap">
                        #
                      </td>
                      <td className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                        {index + 1}
                      </td>
                      <td className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                        {priorityName.taskPriorityName}
                      </td>
                      <td className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                        <div className="flex justify-center gap-2">
                          <button
                            className="rounded-md text-white"
                            onClick={() => handlePrioritySelect(priorityName)}
                          >
                            <BorderColorIcon className="text-[#27004a]" />
                          </button>
                          <div>
                            <button
                              onClick={() => {
                                setOpen11(true);
                              }}
                            >
                              <DeleteIcon className="text-red-500 cursor-pointer" />
                            </button>
                            {open11 && (
                              <ConfirmationModal
                                setClose={() => setOpen11(false)}
                                callback={deletePriority}
                                id={priorityName.id}
                              />
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="h-[100px]">
                    <td
                      colSpan="4"
                      className="py-4 font-semibold text-center text-red-500 text-sm"
                    >
                      Task Priority Not Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {isLoading ? (
            <PaginationSkeleton />
          ) : (
            <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-3 pt-5 w-[100%]">
              <p className="text-[#a5a1a1] text-[14px]">
                Showing 1 to {rowsToShow} of {priorityHeading?.length} entries
              </p>
              <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
                <Link to="#" className="pt-2 pb-[8px] text-[12px]">
                  Previous
                </Link>
                <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
                  1
                </span>
                <Link to="#" className="pt-2 pb-[8px] text-[12px]">
                  Next
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen6}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal6}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="border-[#000] p-3 border-b text-[14px]"
        >
          Edit Task Priority
        </h2>
        <button
          onClick={closeModal6}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>

        <div className="first-panel">
          <div className="p-4">
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Task Priority Name</label>
              <br />
              <input
                type="text"
                placeholder=""
                onChange={(e) => setUpdatePriority(e.target.value)}
                defaultValue={selectedPriority?.taskPriorityName}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button className="first-btn" onClick={closeModal6}>
              Cancel
            </button>
            <button
              className={` ${
                isLoading == true ? "second-btn-disabled" : "second-btn"
              }`}
              onClick={updateTaskPriority}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TaskPriority;
